module.exports = __webpack_public_path__ + "img/Action.c43fa7bd.png";